<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     接入点回收站
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog class="ap-recycle-bin" width="1200px" title="接入点回收站" :visible.sync="dialogShow" append-to-body top="60px" :modal-append-to-body="false"
    @close="onDialogClose">
    <span slot="title">
      <span class="font-md">回收站</span>
      <span class="filter-container">
        <span class="filter-item" style="width: 240px;">
          <el-input v-model="query.keyword" clearable placeholder="接入点编号 / 绑定设备" prefix-icon="el-icon-search"
            @change="fetchList()" />
        </span>
      </span>
    </span>
    <el-table ref="listTable" v-loading="loading" :data="list" tooltip-effect="dark">
      <el-table-column type="index" width="50" label="#" />
      <el-table-column label="接入点编号" :show-overflow-tooltip="true" min-width="120">
        <template slot-scope="scope">
          <!-- <span>{{ scope.row.simid }}</span> -->
          <el-link :underline="false" @click="toDetail(scope.row)">{{ scope.row.simid }}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="类型" min-width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.delete_way == 2">
            <el-tag type="warning">主动添加</el-tag>
          </span>
          <span v-else>
            <el-tag type="info">自动回收</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="绑定设备" :show-overflow-tooltip="true" min-width="140">
        <template slot-scope="scope">
          {{ scope.row.equip_name }}
        </template>
      </el-table-column>
      <el-table-column label="到期时间" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.expire_day | parseTime('{y}/{m}/{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="注销日期" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.deletetime | parseTime('{y}/{m}/{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="60" align="center">
        <template slot-scope="scope">
          <el-popover v-if="scope.row.ap_delete" placement="left" trigger="hover">
            <div class="text-center">已注销，联系客服赎回</div>
            <span slot="reference" class="flex-center font-2x text-success" role="button">
              <span class="iconfont text-muted circle-warning">&#xe68e;</span>
            </span>
          </el-popover>
          <!-- <el-popover v-else placement="left" trigger="hover">
            <div style="width: 120px" class="text-center">点击赎回</div>
            <span slot="reference" class="flex-center font-2x text-success" role="button" @click="recharge(scope.row)">
              <i class="el-icon-money"></i>
            </span>
          </el-popover> -->
        </template>
      </el-table-column>
      <template slot="append">
        <f-table-footer>
          <template slot="right">
            <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchList" />
          </template>
        </f-table-footer>
      </template>
      <div slot="empty" class="flex-center column pb-md">
        <div class="flex-center mt-hg">
          <img src="../../../assets/no-data.png" alt="" class="no-data">
        </div>
      </div>
    </el-table>

    <!-- <div slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">立即赎回</el-button>
      </div> -->
      <ap-recycle-detail v-if="showDeatil" :show.sync="showDeatil" :simid="simid"></ap-recycle-detail>
  </el-dialog>
</template>

<script>
import { apRecycleListApi } from '@/api/ap/apApi'
import ApRecycleDetail from './ApRecycleDetail.vue'
import { apCartPostApi } from '@/api/ap/apRechargeApi'

export default {
  name: 'EiClause',
  components: {
    ApRecycleDetail
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [],
      loading: false,
      query: {
        keyword: '',
        pindex: 1,
        psize: this.$store.state.commonStore.psize
      },
      total: 0,
      showDeatil: false,
      simid: ""
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },
  watch: {
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList(page) {
      if (page) this.query.pindex = page
      this.loading = true
      apRecycleListApi(this.query).then(res => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onDialogClose() {
    },
    toDetail(row) {
      this.showDeatil = true
      this.simid = row.simid
    },
    // recharge(row) {
    //   this.$confirm(`立即前往充值购物车赎回接入点 <span class="text-success">${row.simid}</span>？`, '提示', {
    //     dangerouslyUseHTMLString: true,
    //     confirmButtonText: '确定',
    //     cancelButtonText: '再等等',
    //     type: 'warning'
    //   }).then(() => {
    //     const temp = {
    //       simid: row.simid,
    //       num: 1,
    //       productid: row.productid
    //     }
    //     apCartPostApi({ data: [temp] }).then(res => {
    //       if (!res.errno) {
    //         this.$router.push({ path: '/ap/recharge/cart' })
    //       } else {
    //         this.$message.error(res.message)
    //       }
    //     })
    //   }).catch(() => {
    //   })
    // },
  }
}
</script>

<style lang="scss">
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px; // 横向滚动条
  /*height: 6px; // 纵向滚动条 必写*/
}

// 滚动条的滑块
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}

.el-dialog__body {
  padding: 0 20px 30px;
}

.circle-warning {
  transform: rotate(180deg);
}
.no-data {
  width: 200px;
  height: 200px;
}

</style>
